export default "__VITE_ASSET__50570dd3__"